export const TurkeyFlag = ({
  width = '40',
  height = '30',
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? '1200'}
      height={height ?? '800'}
      viewBox="0 0 60 30">
      <title>Flag of Turkey</title>
      <rect width="60" height="30" fill="#e30a17" />
      <circle cx="26" cy="15" r="9" fill="#fff" />
      <circle cx="29" cy="15" r="7" fill="#e30a17" />
      <path fill="#fff" d="M35 15 l6-2 -3.7 5v-6l3.7 5z" />
    </svg>
  );
};

export const UKFlag = ({
  width = '40',
  height = '30',
}: {
  width?: string;
  height?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 30"
      width={width ?? '1200'}
      height={height ?? '600'}>
      <clipPath id="s">
        <path d="M0,0 v30 h60 v-30 z" />
      </clipPath>
      <clipPath id="t">
        <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
      </clipPath>
      <g clipPath="url(#s)">
        <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
        <path
          d="M0,0 L60,30 M60,0 L0,30"
          clipPath="url(#t)"
          stroke="#C8102E"
          strokeWidth="4"
        />
        <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
        <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
      </g>
    </svg>
  );
};

export const CncMachine = ({
  className,
  size,
  title,
  color,
}: {
  className?: string;
  size?: number;
  title?: string;
  color?: string;
}) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 512}
      className={className}
      height={size ?? 512}
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet">
      <title>{title}</title>
      <a
        href="https://www.flaticon.com/free-icons/cnc-machine"
        title="cnc machine icons">
        Cnc machine icons created by Iconjam - Flaticon
      </a>
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill={color}
        stroke="none">
        <path
          d="M112 5007 c-21 -22 -22 -32 -22 -224 0 -183 2 -203 19 -224 l19 -24
450 -3 449 -3 88 -202 c49 -111 97 -212 108 -224 20 -22 26 -23 219 -23 l198
0 2 -863 3 -863 162 -180 163 -179 0 -266 c0 -344 -16 -317 193 -321 l152 -3
5 -492 c4 -420 7 -494 20 -506 25 -23 303 -260 338 -290 37 -30 68 -34 98 -13
18 14 19 35 24 658 l5 643 152 3 c209 4 193 -23 193 321 l0 266 163 179 162
180 3 863 2 863 198 0 c193 0 199 1 219 23 11 12 59 113 108 224 l88 202 449
3 450 3 19 24 c17 21 19 41 19 225 0 199 0 203 -23 224 l-23 22 -2425 0 -2426
0 -21 -23z m4778 -227 l0 -110 -2330 0 -2330 0 0 110 0 110 2330 0 2330 0 0
-110z m-984 -327 c-19 -43 -49 -113 -67 -155 l-34 -78 -1246 0 -1245 0 -31 73
c-17 39 -47 109 -66 155 l-36 82 1379 0 1379 0 -33 -77z m-568 -1185 l-3 -813
-775 0 -775 0 -3 813 -2 812 780 0 780 0 -2 -812z m-114 -980 c-10 -13 -55
-62 -98 -110 l-79 -88 -487 0 -487 0 -79 88 c-43 48 -88 97 -98 110 l-19 22
683 0 683 0 -19 -22z m-994 -448 c0 -104 1 -112 25 -135 29 -30 64 -32 93 -5
20 19 22 30 22 135 l0 115 60 0 60 0 0 -112 c0 -101 2 -114 22 -135 27 -29 65
-29 95 -1 21 20 23 29 23 135 l0 113 60 0 60 0 0 -115 c0 -105 2 -116 22 -135
29 -27 64 -25 93 5 24 23 25 31 25 135 l0 110 60 0 60 0 0 -200 0 -200 -450 0
-450 0 0 200 0 200 60 0 60 0 0 -110z m430 -976 l0 -545 -34 28 c-18 15 -63
53 -99 83 l-66 55 0 463 -1 462 100 0 100 0 0 -546z"
        />
        <path
          d="M2455 3789 c-90 -18 -194 -76 -266 -148 -282 -282 -174 -747 205
-879 99 -34 233 -34 332 0 379 132 487 597 205 879 -68 68 -116 98 -211 131
-66 23 -195 31 -265 17z m200 -145 c115 -29 203 -103 258 -214 30 -60 32 -72
32 -165 0 -88 -3 -107 -27 -157 -75 -160 -250 -254 -420 -227 -124 20 -241
110 -296 227 -24 50 -27 69 -27 157 0 91 3 106 31 165 52 107 143 184 254 214
72 19 123 19 195 0z"
        />
        <path
          d="M1572 1627 c-43 -46 -33 -62 136 -230 87 -86 164 -157 170 -157 38 0
82 44 82 82 0 6 -71 83 -157 170 -169 170 -188 181 -231 135z"
        />
        <path
          d="M3317 1492 c-86 -87 -157 -164 -157 -170 0 -38 44 -82 82 -82 6 0 83
71 170 157 170 169 181 188 135 231 -46 43 -62 33 -230 -136z"
        />
        <path
          d="M1377 1182 c-10 -10 -17 -34 -17 -53 0 -30 15 -49 148 -181 129 -128
153 -148 180 -148 40 0 72 31 72 68 0 22 -29 57 -153 180 -130 130 -157 152
-183 152 -17 0 -38 -8 -47 -18z"
        />
        <path
          d="M1710 1180 c-42 -42 -30 -63 132 -227 133 -134 156 -153 184 -153 42
0 78 42 69 80 -3 14 -69 88 -154 173 -128 128 -151 147 -179 147 -19 0 -40 -8
-52 -20z"
        />
        <path
          d="M3179 1053 c-85 -85 -151 -159 -154 -173 -9 -38 27 -80 69 -80 28 0
51 19 184 153 120 121 152 159 152 180 0 37 -33 67 -72 67 -28 0 -51 -19 -179
-147z"
        />
        <path
          d="M3512 1047 c-122 -122 -152 -158 -152 -180 0 -37 32 -67 72 -67 27 0
51 19 180 148 135 135 148 152 148 184 0 42 -25 68 -66 68 -24 0 -54 -25 -182
-153z"
        />
        <path
          d="M1036 1168 c-34 -48 -24 -64 137 -225 132 -132 157 -153 184 -153 41
0 77 42 68 80 -3 14 -70 89 -153 173 -136 137 -149 147 -184 147 -27 0 -41 -6
-52 -22z"
        />
        <path
          d="M3848 1043 c-83 -84 -150 -159 -153 -173 -9 -38 27 -80 68 -80 27 0
52 21 184 153 161 161 171 177 137 225 -11 16 -25 22 -52 22 -35 0 -48 -10
-184 -147z"
        />
        <path
          d="M110 660 c-19 -19 -20 -33 -20 -273 0 -252 0 -254 23 -275 l23 -22
1042 0 c1029 0 1042 0 1062 20 40 40 29 65 -143 322 l-162 243 -902 3 c-892 2
-903 2 -923 -18z m1843 -262 c51 -79 96 -149 101 -156 6 -9 -179 -12 -908 -12
l-916 0 0 155 0 155 815 0 815 0 93 -142z"
        />
        <path
          d="M3318 668 c-27 -21 -328 -489 -328 -510 0 -10 11 -30 25 -43 l24 -25
974 0 974 0 21 23 c21 23 22 30 22 275 0 239 -1 253 -20 272 -20 20 -33 20
-848 20 -647 0 -832 -3 -844 -12z m1572 -283 l0 -155 -850 0 -850 0 102 155
103 154 748 1 747 0 0 -155z"
        />
      </g>
    </svg>
  );
};

export const Facebook = ({
  className,
  size,
}: {
  className?: string;
  size?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 24}
      height={size ?? 24}
      className={className}
      viewBox="0 0 512 512">
      <title>Facebook</title>
      <path
        d="M480 257.35c0-123.7-100.3-224-224-224s-224 100.3-224 224c0 111.8 81.9 204.47 189 221.29V322.12h-56.89v-64.77H221V208c0-56.13 33.45-87.16 84.61-87.16 24.51 0 50.15 4.38 50.15 4.38v55.13H327.5c-27.81 0-36.51 17.26-36.51 35v42h62.12l-9.92 64.77H291v156.54c107.1-16.81 189-109.48 189-221.31z"
        fillRule="evenodd"
      />
    </svg>
  );
};

export const Linkedin = ({
  className,
  size,
}: {
  className?: string;
  size?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 24}
      height={size ?? 24}
      className={className}
      viewBox="0 0 512 512">
      <title>Linkedin</title>
      <path d="M444.17 32H70.28C49.85 32 32 46.7 32 66.89v374.72C32 461.91 49.85 480 70.28 480h373.78c20.54 0 35.94-18.21 35.94-38.39V66.89C480.12 46.7 464.6 32 444.17 32zm-273.3 373.43h-64.18V205.88h64.18zM141 175.54h-.46c-20.54 0-33.84-15.29-33.84-34.43 0-19.49 13.65-34.42 34.65-34.42s33.85 14.82 34.31 34.42c-.01 19.14-13.31 34.43-34.66 34.43zm264.43 229.89h-64.18V296.32c0-26.14-9.34-44-32.56-44-17.74 0-28.24 12-32.91 23.69-1.75 4.2-2.22 9.92-2.22 15.76v113.66h-64.18V205.88h64.18v27.77c9.34-13.3 23.93-32.44 57.88-32.44 42.13 0 74 27.77 74 87.64z" />
    </svg>
  );
};

export const Instagram = ({
  className,
  size,
}: {
  className?: string;
  size?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 24}
      height={size ?? 24}
      className={className}
      viewBox="0 0 512 512">
      <title>Instagram</title>
      <path d="M349.33 69.33a93.62 93.62 0 0193.34 93.34v186.66a93.62 93.62 0 01-93.34 93.34H162.67a93.62 93.62 0 01-93.34-93.34V162.67a93.62 93.62 0 0193.34-93.34h186.66m0-37.33H162.67C90.8 32 32 90.8 32 162.67v186.66C32 421.2 90.8 480 162.67 480h186.66C421.2 480 480 421.2 480 349.33V162.67C480 90.8 421.2 32 349.33 32z" />
      <path d="M377.33 162.67a28 28 0 1128-28 27.94 27.94 0 01-28 28zM256 181.33A74.67 74.67 0 11181.33 256 74.75 74.75 0 01256 181.33m0-37.33a112 112 0 10112 112 112 112 0 00-112-112z" />
    </svg>
  );
};

export const Whatsapp = ({
  className,
  size,
  title,
  color,
}: {
  className?: string;
  size?: number;
  title?: string;
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 24}
      height={size ?? 24}
      className={className}
      viewBox="0 0 24 24">
      <title>{title}</title>
      <path
        fill={color}
        d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.77-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.006c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.86s.274.072.376-.043c.101-.116.433-.506.549-.68.116-.173.231-.145.39-.087s1.011.477 1.184.564.289.13.332.202c.045.072.045.419-.1.824zm-3.423-14.416c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm.029 18.88c-1.161 0-2.305-.292-3.318-.844l-3.677.964.984-3.595c-.607-1.052-.927-2.246-.926-3.468.001-3.825 3.113-6.937 6.937-6.937 1.856.001 3.598.723 4.907 2.034 1.31 1.311 2.031 3.054 2.03 4.908-.001 3.825-3.113 6.938-6.937 6.938z"
      />
    </svg>
  );
};

export const Email = ({
  className,
  size,
}: {
  className?: string;
  size?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 24}
      height={size ?? 24}
      className={className}
      viewBox="0 0 24 24">
      <title>Email</title>
      <path d="M20 4H6c-1.103 0-2 .897-2 2v5h2V8l6.4 4.8a1.001 1.001 0 0 0 1.2 0L20 8v9h-8v2h8c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zm-7 6.75L6.666 6h12.668L13 10.75z"></path>
      <path d="M2 12h7v2H2zm2 3h6v2H4zm3 3h4v2H7z"></path>
    </svg>
  );
};

export const Email2 = ({
  className,
  size,
  color,
}: {
  className?: string;
  size?: number;
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 122.88}
      height={size ?? 88.86}
      className={className}
      viewBox="0 0 122.88 88.86">
      <title>Email</title>
      <path
        fill={color}
        d="M7.05,0H115.83a7.07,7.07,0,0,1,7,7.05V81.81a7,7,0,0,1-1.22,4,2.78,2.78,0,0,1-.66,1,2.62,2.62,0,0,1-.66.46,7,7,0,0,1-4.51,1.65H7.05a7.07,7.07,0,0,1-7-7V7.05A7.07,7.07,0,0,1,7.05,0Zm-.3,78.84L43.53,40.62,6.75,9.54v69.3ZM49.07,45.39,9.77,83.45h103L75.22,45.39l-11,9.21h0a2.7,2.7,0,0,1-3.45,0L49.07,45.39Zm31.6-4.84,35.46,38.6V9.2L80.67,40.55ZM10.21,5.41,62.39,47.7,112.27,5.41Z"
      />
    </svg>
  );
};

export const Goods = ({
  className,
  size,
  title,
}: {
  className?: string;
  size?: number;
  title?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      imageRendering="optimizeQuality"
      fillRule="evenodd"
      clipRule="evenodd"
      width={size ?? 24}
      height={size ?? 24}
      className={className}
      viewBox="0 0 512 502.92">
      <title>{title}</title>
      <path
        fillRule="nonzero"
        d="M248.22 301.3 76.33 211.14l-44.37 52.61c62.12 32.84 119.75 63.86 181.9 96.71l34.36-59.16zM382.59 57.73l.62 124.11c.03 6.48-4.05 12.05-9.86 14.39l.01.03-107.84 47.9c-4.12 1.64-11.68 1.89-15.7.2l-99.4-46.08.01-.03c-5.74-2.41-9.78-8.14-9.75-14.82l.59-122.53c-.45-7.57 2.66-14.93 10.11-17.93L255.11 1.19c4.23-1.7 8.77-1.51 12.63.15L371.3 38.79c6.2 2.24 10.12 7.81 10.4 13.84.59 1.64.89 3.37.89 5.1zM247.16 220.38V103.91l-91.14-35.9-1.75 112.62 92.89 39.75zm21.57-116.45v116.35l98.7-40.92L366.87 66l-98.14 37.93zm-155.25 81.16L88 197.72l171.34 90.04 171.67-90.21-20.6-10.71-.09-19.64 25.86 13.35 48.4-45.88-74.63-40.37-.1-20.78 98.65 52.15c.58.31 1.12.71 1.61 1.21 2.55 2.59 2.51 6.75-.07 9.3l-59.01 57.94 57.14 68.39c2.32 2.78 1.95 6.94-.82 9.27-.43.35-.88.65-1.35.87l-51.29 27.12v101.66c0 2.73-1.69 5.09-4.07 6.08l-185.46 94.14c-4.38 2.07-6.05 1.61-10.76-1.46L68.62 407.3a6.557 6.557 0 0 1-3.63-5.87l-.04-101.16-52.25-27.62c-.47-.22-.91-.52-1.34-.87-2.78-2.33-3.15-6.49-.82-9.27l55.66-66.6-64.58-61.2c-2.39-2.72-2.1-6.87.63-9.27.4-.34.82-.64 1.25-.87l110.57-62.55-.1 21.14-88.63 50.42 52.64 48.94 35.6-17.63-.1 20.2zm329.87 26.72-171.58 89.98 33.42 59.3 180.52-97.93-42.36-51.35z"
      />
    </svg>
  );
};

export const Delivery = ({
  className,
  size,
  title,
  color,
}: {
  className?: string;
  size?: number;
  title?: string;
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 122.88 78.78"
      fillRule="evenodd"
      width={size ?? 24}
      height={size ?? 24}
      className={className}>
      <title>{title}</title>
      <path
        fill={color}
        d="M90.53,24.33,82,24.27V12.8a6.21,6.21,0,0,0-6.19-6.19H50.72a30.05,30.05,0,0,1,2,3.36H75.85a2.86,2.86,0,0,1,2,.83,2.83,2.83,0,0,1,.83,2V65.34H69.22a1.68,1.68,0,1,0,0,3.35H80.36A1.67,1.67,0,0,0,82,67V65.11h6.78c.77-17.46,25.84-19.87,28.4,0h5.5c1.42-17-7-23.65-19.77-25.14a45.78,45.78,0,0,0-4.66-11.38c-2.36-4.36-2.91-4.18-7.76-4.26ZM16.27,20.05,20.74,20l.33.08a17.34,17.34,0,0,1,2.54,1.79,16.26,16.26,0,0,1,1.64,1.58,104.87,104.87,0,0,1,6.52-9,116,116,0,0,1,8.32-9.14l.44-.16H45.4l-1,1.09a162.08,162.08,0,0,0-10.29,13A141.12,141.12,0,0,0,26.06,32.2l-.61,1.18-.56-1.21a29.27,29.27,0,0,0-3.77-6.1,24.5,24.5,0,0,0-5.21-4.83l.36-1.19ZM35,39.26a1.6,1.6,0,1,1-2.77,1.6l-.87-1.5a1.6,1.6,0,1,1,2.77-1.6l.87,1.5ZM14.42,10.11a1.6,1.6,0,1,1,2.77-1.6l.87,1.5a1.6,1.6,0,1,1-2.77,1.6l-.87-1.5ZM40.86,32.18A1.6,1.6,0,1,1,39.26,35l-1.5-.87a1.6,1.6,0,1,1,1.6-2.77l1.5.87ZM8.51,17.2a1.6,1.6,0,0,1,1.6-2.78l1.5.87A1.6,1.6,0,1,1,10,18.06l-1.5-.86Zm33.93,5.88a1.61,1.61,0,1,1,0,3.21H40.7a1.61,1.61,0,0,1,0-3.21ZM6.93,26.29a1.61,1.61,0,1,1,0-3.21H8.66a1.61,1.61,0,1,1,0,3.21ZM10.11,35a1.6,1.6,0,1,1-1.6-2.77l1.5-.87a1.6,1.6,0,1,1,1.6,2.77l-1.5.87Zm7.08,5.91a1.6,1.6,0,1,1-2.77-1.6l.87-1.5a1.6,1.6,0,1,1,2.77,1.6l-.87,1.5ZM23.08,6.93a1.61,1.61,0,1,1,3.21,0V8.67a1.61,1.61,0,0,1-3.21,0V6.93Zm3.21,35.51a1.61,1.61,0,1,1-3.21,0V40.71a1.61,1.61,0,1,1,3.21,0v1.73ZM24.68,0A24.64,24.64,0,0,1,35.79,2.63c-.65.64-1.34,1.36-2,2.11A21.91,21.91,0,1,0,44,14.37c.63-.79,1.27-1.56,1.9-2.3A24.69,24.69,0,1,1,24.68,0Zm10,65.33a1.68,1.68,0,0,1,0,3.36H16.82a6.07,6.07,0,0,1-4.37-1.91,6.48,6.48,0,0,1-1.82-4.45V53.1A32.11,32.11,0,0,0,14,54.53v7.8a3.11,3.11,0,0,0,.88,2.14,2.72,2.72,0,0,0,1.95.87H34.65ZM51.72,56A11.37,11.37,0,1,0,63.08,67.41,11.37,11.37,0,0,0,51.72,56Zm0,7a4.37,4.37,0,1,0,4.37,4.37A4.38,4.38,0,0,0,51.72,63ZM103,54.37a11.37,11.37,0,1,0,11.37,11.37A11.37,11.37,0,0,0,103,54.37ZM98.61,65.74A4.37,4.37,0,1,0,103,61.37a4.37,4.37,0,0,0-4.37,4.37ZM91.35,29.18l-5.12-.09V40H97.08a42.13,42.13,0,0,0-5.73-10.8Z"
      />
    </svg>
  );
};

export const Quality = ({
  className,
  size,
  title,
  color,
}: {
  className?: string;
  size?: number;
  title?: string;
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 92.35 122.88"
      width={size ?? 24}
      height={size ?? 24}
      fillRule="evenodd"
      className={className}>
      <title>{title}</title>
      <path
        fill={color}
        d="M3.39,113.07,15,111l5.73,10.25c4.15,5.15,6.79-3.31,8-6.26L39.78,94c-2.57-.89-5.66-3.47-8.85-6.35-6.35.13-12.26-1-16.62-6.52L1.5,105.85.38,108.23c-.87,3.08-.41,5.12,3,4.84ZM46.77,27l3.79,8.88,9.62.86a.78.78,0,0,1,.7.83.81.81,0,0,1-.26.52h0l-7.27,6.35,2.15,9.41a.78.78,0,0,1-1.18.82L46.06,49.7l-8.29,4.95a.77.77,0,0,1-1.05-.26.73.73,0,0,1-.09-.57h0l2.15-9.41-7.27-6.35A.77.77,0,0,1,31.43,37a.79.79,0,0,1,.54-.26l9.59-.86L45.35,27a.77.77,0,0,1,1-.41.72.72,0,0,1,.41.41ZM46.18,0a9.26,9.26,0,0,1,5.61,1.76C54,3.16,56.45,5.91,59.5,7.65c4.28,2.45,12.22-.93,16.29,5.11,2.37,3.52,2.48,6.28,2.66,9a15.84,15.84,0,0,0,3.72,9.64c5,6.59,6,11,3.45,15.56-1.75,3.11-5.44,4.85-6.29,6.82-1.82,4.2.19,7.37-2.3,12.27a13.05,13.05,0,0,1-7.93,6.78c-3,1-6-.43-8.39.58C56.5,75.19,53.39,79.3,50,80.34a13,13,0,0,1-7.73,0c-3.35-1-6.46-5.15-10.66-6.92-2.4-1-5.4.39-8.39-.58a13,13,0,0,1-7.94-6.78C12.83,61.16,14.84,58,13,53.79c-.86-2-4.55-3.71-6.3-6.82-2.57-4.58-1.53-9,3.46-15.56,3-4,3.53-6.7,3.72-9.64.17-2.73.28-5.49,2.65-9,4.07-6,12-2.66,16.3-5.11,3-1.74,5.51-4.49,7.71-5.88A9.24,9.24,0,0,1,46.18,0Zm-.12,16.93A24.15,24.15,0,1,1,21.91,41.09,24.15,24.15,0,0,1,46.06,16.94ZM89,113.07,77.41,111l-5.73,10.25c-4.16,5.15-6.8-3.31-8-6.26L52.57,94c2.57-.89,5.67-3.47,8.85-6.35,6.35.13,12.27-1,16.62-6.52l12.82,24.76L92,108.23c.87,3.08.41,5.12-3,4.84Z"
      />
    </svg>
  );
};

export const Stars = ({
  className,
  size,
  title,
}: {
  className?: string;
  size?: number;
  title?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      imageRendering="optimizeQuality"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 512 273.23"
      width={size ?? 512}
      height={size ?? 273}
      className={className}>
      <title>{title}</title>
      <path
        fillRule="nonzero"
        d="m404.63 17.77 26.89 62.95 68.58 6.13c3.52.42 6.6 2.19 8.74 4.73 2.15 2.56 3.35 5.9 3.13 9.44l-.07.85c-.2 1.6-.67 3.11-1.36 4.48l-.32.57c-.59 1.03-1.32 1.98-2.15 2.81l-52.28 45.69 15.26 66.77c.84 3.62.11 7.27-1.73 10.19-1.83 2.9-4.8 5.14-8.43 5.96-1.79.4-3.62.43-5.36.12-1.69-.3-3.3-.93-4.74-1.83l-58.58-35.01-27.34 16.34-3.63-15.61 27.01-16.15a7.633 7.633 0 0 1 7.88-.03l59.09 35.32-15.34-67.1c-.59-2.66.23-5.54 2.42-7.46l51.85-45.27-68.1-6.12a7.621 7.621 0 0 1-6.8-4.64l-27.04-63.3-17.94 42.02-16.02-1.44 21.55-50.45c1.45-3.42 4.16-5.93 7.36-7.22 3.21-1.3 6.91-1.36 10.34.1l.59.28c1.4.67 2.64 1.57 3.66 2.6 1.23 1.19 2.19 2.67 2.88 4.28zM262.89 4.59l36.63 85.78 92.92 8.34c4.1.35 7.14 3.96 6.78 8.06-.17 2-1.12 3.74-2.52 4.96l-70.29 61.38 20.79 90.99c.93 4.01-1.59 8.02-5.61 8.94-2.05.47-4.11.04-5.75-1.03L256 224.27l-80.1 47.89c-3.53 2.11-8.1.96-10.22-2.58a7.365 7.365 0 0 1-.87-5.48l-.01-.01 20.8-90.98-70.3-61.38a7.445 7.445 0 0 1-.7-10.52 7.448 7.448 0 0 1 5.21-2.53l92.67-8.31 36.65-85.82c1.62-3.8 6-5.57 9.79-3.95 1.87.79 3.25 2.26 3.97 3.99zM119.79 27.6 92.75 90.9a7.61 7.61 0 0 1-6.8 4.64l-68.1 6.12 51.85 45.27a7.653 7.653 0 0 1 2.42 7.46l-15.33 67.1 59.08-35.32c2.51-1.5 5.53-1.39 7.88.03l27.05 16.17-3.57 15.65-27.44-16.4-58.58 35.02c-1.44.89-3.05 1.52-4.74 1.82-1.74.31-3.57.28-5.35-.12-3.65-.82-6.61-3.06-8.44-5.96-1.83-2.93-2.56-6.57-1.73-10.19l15.26-66.77-52.28-45.69c-.83-.83-1.56-1.78-2.15-2.81l-.31-.57c-.7-1.37-1.17-2.88-1.37-4.48l-.07-.82c-.22-3.56.98-6.9 3.13-9.47 2.14-2.55 5.22-4.31 8.75-4.73l68.57-6.13 26.89-62.95c.69-1.61 1.66-3.09 2.86-4.29 1.04-1.02 2.27-1.91 3.67-2.58l.61-.29c3.41-1.46 7.12-1.4 10.33-.11 3.2 1.3 5.91 3.81 7.36 7.23l21.54 50.43-16 1.44-17.95-42z"
      />
    </svg>
  );
};

export const Earth = ({
  className,
  size,
  title,
}: {
  className?: string;
  size?: number;
  title?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      viewBox="0 0 122.88 122.879"
      width={size ?? 122.88}
      height={size ?? 122.879}
      className={className}
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      enableBackground="new 0 0 122.88 122.879">
      <title>{title}</title>
      <g>
        <path d="M118.438,61.495c-0.078,1.147-0.11,2.085-0.11,2.534c0,1.06-0.741,1.945-1.733,2.167l-2.918,0.896 c-0.217,0.066-0.436,0.099-0.651,0.099v0.006h-0.464c-1.034,0-1.904-0.708-2.15-1.666l-2.556-7.787l-0.006-0.019l-0.003,0.001 l-0.464-1.467l-4.329,7.777c-0.187,0.335-0.446,0.603-0.749,0.794l0.003,0.004l-2.256,1.431c-1.035,0.656-2.406,0.35-3.063-0.685 c-0.166-0.262-0.27-0.545-0.316-0.832l-2.194-12.321l-3.321-2.353l-7.793-1.391c0.267,0.423,0.538,0.841,0.806,1.254 c1.388,2.142,2.685,4.143,3.115,6.205c0.693,3.315-0.544,6.087-6.063,8.067c0.159,0.096,0.316,0.201,0.472,0.32 c2.15,1.645,2.668,4.071-2.021,10.196c-1.184,1.547-2.202,2.914-3.057,4.102c-0.672,0.935-1.299,1.835-1.876,2.7l1.055,7.676 c0.142,1.034-0.106,2.04-0.772,3.009c-0.494,0.719-1.224,1.402-2.202,2.043c-0.646,0.424-1.198,0.85-1.65,1.277 c-0.179,0.168-0.341,0.336-0.488,0.502l0.485,2.193c0.232,1.051-0.324,2.092-1.275,2.505l0.001,0.002l-0.813,0.354 c-0.161,0.63-0.393,1.248-0.691,1.854c-0.482,0.974-1.15,1.926-2.001,2.854c-0.906,0.991-1.904,1.741-2.992,2.249 c-1.136,0.531-2.333,0.796-3.594,0.796h-3.908c-1.226,0-2.221-0.994-2.221-2.221c0-1.003-0.122-2.067-0.363-3.195 c-0.25-1.167-0.631-2.417-1.141-3.751c-0.575-1.504-1.014-2.865-1.316-4.083c-0.322-1.298-0.483-2.422-0.483-3.374 c0-0.85,0.073-1.611,0.219-2.284c0.173-0.803,0.452-1.485,0.836-2.048c0.04-0.059,0.085-0.227,0.136-0.506 c0.078-0.429,0.118-1.018,0.118-1.771c0-0.573-0.099-1.176-0.294-1.808c-0.217-0.7-0.552-1.447-1.002-2.236 c-0.562-0.985-0.986-1.78-1.271-2.383c-0.41-0.865-0.615-1.559-0.615-2.074c0-3.625-1.243-4.424-2.969-4.424 c-1.037,0-2.204,0.158-3.417,0.323c-1.511,0.205-3.084,0.418-4.629,0.418c-1.165,0-2.315-0.532-3.437-1.588 c-0.827-0.778-1.692-1.906-2.583-3.375c-0.808-1.331-1.418-2.406-1.832-3.216c-0.57-1.116-0.854-1.971-0.854-2.543 c0-1.463-0.001-1.588-0.002-1.705c-0.059-6.162-0.113-11.989,5.83-16.283c2.464-3.503,4.683-5.775,7.352-7.221 c2.779-1.506,5.871-2.033,10.052-2.033c1.226,0,2.221,0.995,2.221,2.221v3.149l2.664,1.166l0.038-0.181 c0.254-1.197,1.431-1.962,2.628-1.709l0.009,0.002v-0.002c0.824,0.178,1.574,0.389,2.256,0.637c0.73,0.266,1.361,0.569,1.898,0.915 c0.281,0.182,0.786,0.343,1.392,0.449c0.678,0.118,1.405,0.142,2.019,0.02c0.326-0.065,0.57-0.142,0.641-0.226l0.001-0.006 c-0.001,0-0.002,0-0.001-0.002l0.014-0.071c0.056-0.331,0.104-0.666,0.145-1.004l-2.637,0.235 c-0.948,0.082-1.808-0.446-2.191-1.259l-0.004,0.001c-0.87-1.83-2.708-2.769-5.015-3.946c-2.48-1.266-5.4-2.757-8.545-5.751 c-10.613,3.765-14.004,4.283-14.854,1.916c-0.5-1.388,0.218-2.499,1.185-3.995c0.872-1.349,2.113-3.267,2.113-5.069 c0-0.965,0.617-1.787,1.478-2.093l8.934-4.081l-0.002,0c-0.963-0.17-2.156-0.382-3.145-5.189c-0.202-0.987,0.288-1.955,1.137-2.401 l-0.001-0.002c0.697-0.367,1.515-0.868,2.454-1.504c0.952-0.645,2.091-1.473,3.419-2.487l0.084-0.064 c-4.542,0.707-8.909,1.954-13.096,3.743l0.001,0.003c-3.494,1.503-6.751,3.263-9.766,5.285c-3.02,2.027-5.818,4.328-8.392,6.911 l-0.009,0.009l0,0c-2.583,2.574-4.884,5.372-6.91,8.392c-2.023,3.014-3.783,6.271-5.286,9.766 c-0.016,0.036-0.032,0.071-0.049,0.106C7.38,42.76,6.288,46.302,5.553,49.97c-0.741,3.703-1.111,7.527-1.111,11.47 c0,3.943,0.371,7.768,1.112,11.471c0.04,0.199,0.081,0.399,0.124,0.6l10.271,4.911c0.768,0.368,1.228,1.121,1.256,1.917h0.001 c0.11,2.936-0.673,5.107-1.477,7.334c-0.598,1.656-1.209,3.35-1.307,5.344c-0.01,0.211-0.049,0.413-0.113,0.604 c1.991,2.938,4.244,5.665,6.765,8.178l0.009,0.009v-0.001c2.573,2.583,5.372,4.885,8.392,6.911 c3.014,2.022,6.271,3.783,9.766,5.286c0.036,0.015,0.071,0.031,0.106,0.049c3.414,1.449,6.957,2.541,10.625,3.275 c3.703,0.741,7.527,1.111,11.47,1.111c3.942,0,7.767-0.37,11.469-1.111c3.707-0.742,7.285-1.85,10.732-3.321l-0.002-0.003 c3.495-1.503,6.752-3.264,9.767-5.286c3.019-2.026,5.817-4.328,8.392-6.911l0.009-0.008l0,0c2.582-2.573,4.884-5.372,6.909-8.392 c2.023-3.014,3.783-6.271,5.286-9.766c0.016-0.036,0.031-0.071,0.049-0.106c1.45-3.414,2.542-6.956,3.276-10.623 C118.064,69.225,118.435,65.419,118.438,61.495L118.438,61.495z M37.497,4.801C44.986,1.6,52.975,0,61.44,0 c4.23,0,8.344,0.399,12.336,1.198c3.943,0.79,7.776,1.975,11.495,3.555c0.04,0.015,0.081,0.031,0.121,0.048 c3.71,1.596,7.204,3.488,10.477,5.685c3.265,2.19,6.286,4.674,9.06,7.457l0.009,0.009c2.783,2.774,5.267,5.795,7.457,9.06 c2.195,3.272,4.089,6.767,5.685,10.477l-0.004,0.001l0.004,0.007c1.604,3.754,2.805,7.624,3.603,11.606 c0.799,3.992,1.198,8.106,1.198,12.337c0,4.231-0.399,8.345-1.198,12.337c-0.789,3.944-1.976,7.777-3.556,11.496 c-0.015,0.04-0.03,0.079-0.047,0.119c-1.596,3.71-3.489,7.204-5.685,10.477c-2.19,3.265-4.674,6.286-7.457,9.06l-0.009,0.009 c-2.773,2.783-5.795,5.267-9.06,7.457c-3.272,2.196-6.767,4.089-10.477,5.685l-0.001-0.003l-0.008,0.003 c-3.754,1.604-7.624,2.806-11.606,3.603c-3.993,0.799-8.106,1.198-12.337,1.198c-4.231,0-8.345-0.399-12.337-1.198 c-3.943-0.789-7.775-1.974-11.494-3.555c-0.041-0.015-0.081-0.03-0.121-0.048c-3.71-1.596-7.204-3.488-10.478-5.685 c-3.264-2.19-6.286-4.674-9.06-7.457l-0.009-0.009c-2.782-2.773-5.266-5.795-7.456-9.06c-2.196-3.272-4.089-6.767-5.685-10.477 l0.003-0.002l-0.003-0.007c-1.604-3.754-2.806-7.623-3.603-11.606C0.4,69.784,0,65.671,0,61.439c0-4.231,0.4-8.345,1.199-12.337 c0.789-3.943,1.975-7.776,3.556-11.496c0.015-0.04,0.03-0.079,0.047-0.119c1.596-3.71,3.488-7.205,5.685-10.477 c2.19-3.264,4.674-6.286,7.456-9.06l0.009-0.009c2.774-2.783,5.796-5.267,9.06-7.457c3.273-2.196,6.768-4.089,10.478-5.685 l0.001,0.003L37.497,4.801L37.497,4.801z M9.681,83.705c0.483,1.118,1.011,2.225,1.583,3.315c0.1-0.282,0.2-0.563,0.301-0.841 c0.517-1.431,1.023-2.834,1.176-4.389L8.08,79.562c0.466,1.383,0.999,2.763,1.601,4.135l-0.003,0.001L9.681,83.705L9.681,83.705z M86.745,10.755c-2.06-1.036-4.204-1.952-6.432-2.744c-8.247,1.899-10.632,0.76-13.277-0.505c-1.345-0.643-2.78-1.33-5.946-1.33 h-1.894c-0.191,0-0.59,0.162-1.198,0.487c-0.812,0.435-1.831,1.118-3.058,2.054c-1.312,1.001-2.52,1.875-3.627,2.625 c-0.645,0.437-1.235,0.816-1.771,1.14c1.058,0.244,1.866,0.906,2.429,5.855l-0.004,0c0.102,0.923-0.389,1.848-1.28,2.255 l-8.394,3.834c-0.409,2.436-1.735,4.488-2.716,6.005c-0.02,0.032-0.043,0.056-0.067,0.073c1.064-0.636,3.626-2.784,9.72-4.992 c0.828-0.359,1.827-0.186,2.485,0.506c2.991,3.128,5.926,4.625,8.377,5.877c2.569,1.311,4.7,2.399,6.22,4.628l3.585-0.32 c0.129-0.023,0.263-0.036,0.399-0.036c1.226,0,2.221,0.994,2.221,2.22c0,0.691-0.032,1.402-0.095,2.125 c-0.06,0.666-0.149,1.356-0.271,2.065c-0.004,0.026-0.008,0.053-0.013,0.079c-0.105,0.606-0.324,1.147-0.633,1.627 c-0.789,1.227-2.07,1.911-3.512,2.198c-1.17,0.233-2.477,0.202-3.648-0.002c-1.159-0.202-2.252-0.595-3.023-1.091 c-0.162-0.104-0.349-0.204-0.561-0.299l-0.103,0.485h-0.002c-0.031,0.143-0.076,0.286-0.137,0.425 c-0.489,1.121-1.793,1.633-2.915,1.145l-6.331-2.772c-0.868-0.301-1.492-1.127-1.492-2.098V39.97 c-2.333,0.15-4.157,0.576-5.732,1.43c-2.052,1.111-3.859,3.028-5.982,6.081c-0.157,0.253-0.369,0.478-0.63,0.656 c-4.338,2.978-4.293,7.763-4.246,12.829c0.01,1.025,0.02,1.43,0.02,1.74c0,0.104,0.117,0.071,0.352,0.53 c0.371,0.727,0.929,1.708,1.676,2.938c0.67,1.104,1.286,1.919,1.838,2.438c0.263,0.248,0.398,0.373,0.401,0.373 c1.339,0,2.717-0.187,4.04-0.366c1.408-0.19,2.763-0.374,4.006-0.374c4.31,0,7.41,1.599,7.41,8.864 c0,0.134,0.061-0.072,0.182,0.184c0.246,0.52,0.618,1.216,1.115,2.088c0.606,1.063,1.069,2.104,1.384,3.121 c0.334,1.077,0.503,2.115,0.503,3.108c0,0.97-0.07,1.826-0.205,2.568c-0.166,0.904-0.444,1.64-0.831,2.206 c-0.057,0.084-0.11,0.24-0.16,0.469c-0.076,0.353-0.114,0.808-0.114,1.365c0,0.619,0.115,1.391,0.344,2.315 c0.25,1.005,0.636,2.192,1.16,3.563c0.584,1.529,1.03,2.999,1.332,4.41c0.138,0.646,0.247,1.278,0.323,1.894h1.832 c0.63,0,1.204-0.12,1.72-0.361c0.563-0.264,1.099-0.672,1.605-1.226c0.553-0.605,0.983-1.216,1.288-1.832 c0.267-0.537,0.431-1.07,0.489-1.598c0.055-0.799,0.541-1.541,1.325-1.883l0.225-0.099l-0.311-1.404l0,0 c-0.122-0.552-0.033-1.15,0.295-1.665c0.454-0.713,1.021-1.39,1.696-2.027c0.656-0.621,1.411-1.209,2.258-1.764 c0.498-0.326,0.823-0.607,0.987-0.846c0.001-0.001,0.002,0,0.003,0.002l0.013,0.009l-1.139-8.282 c-0.108-0.549-0.011-1.138,0.319-1.643c0.641-0.979,1.457-2.16,2.449-3.54c0.962-1.336,2.006-2.74,3.127-4.205 c2.463-3.219,2.927-3.931,2.854-3.986c-0.152-0.117-0.521-0.269-0.908-0.427c-1.513-0.619-3.179-1.303-3.964-3.537 c-0.043-0.111-0.077-0.228-0.103-0.348c-0.249-1.197,0.52-2.371,1.718-2.619c6.022-1.259,7.51-2.595,7.2-4.076 c-0.262-1.256-1.339-2.917-2.491-4.695c-1.148-1.771-2.361-3.644-3.177-5.69c-0.193-0.402-0.267-0.866-0.185-1.339 c0.211-1.207,1.36-2.015,2.567-1.804l12.731,2.272l-0.001,0.009c0.313,0.055,0.618,0.177,0.895,0.373l4.327,3.065 c0.549,0.317,0.959,0.866,1.076,1.54l1.619,9.089l5.624-10.104c0.254-0.546,0.727-0.988,1.346-1.183 c1.169-0.369,2.416,0.28,2.785,1.449l2.015,6.366l-0.003,0l1.881,5.73c0.07-1.222,0.197-2.811,0.401-4.4 c0.208-1.617,0.499-3.231,0.898-4.469c0.292-0.908,0.672-1.679,1.156-2.253c-0.331-2.111-0.783-4.189-1.358-6.232 c-0.694-2.464-1.568-4.867-2.621-7.205c-1.066-2.356-2.265-4.602-3.598-6.743c-1.347-2.161-2.812-4.196-4.401-6.111 c-1.606-1.926-3.338-3.729-5.19-5.409c-1.839-1.666-3.82-3.224-5.942-4.671C91.198,13.188,89.011,11.895,86.745,10.755 L86.745,10.755z M71.405,89.793l-0.011-0.085l-0.013-0.009C71.392,89.72,71.415,89.86,71.405,89.793L71.405,89.793z M38.844,30.524 c0.085,0.237,0.265,0.216,0.629,0.004L38.844,30.524L38.844,30.524z" />
      </g>
    </svg>
  );
};

export const Professional = ({
  className,
  size,
  title,
  color,
}: {
  className?: string;
  size?: number;
  title?: string;
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      imageRendering="optimizeQuality"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 512 512"
      width={size ?? 512}
      height={size ?? 512}
      className={className}>
      <title>{title}</title>
      <path
        fillRule="nonzero"
        fill={color}
        d="M423.51 61.53c-5.02,-5.03 -10.92,-7.51 -17.75,-7.51 -6.82,0 -12.8,2.48 -17.75,7.51l-27.05 26.97c-7.25,-4.7 -14.93,-8.8 -22.95,-12.47 -8.02,-3.67 -16.22,-6.82 -24.5,-9.55l0 -41.48c0,-7 -2.38,-12.89 -7.25,-17.75 -4.86,-4.86 -10.75,-7.25 -17.75,-7.25l-52.05 0c-6.66,0 -12.45,2.39 -17.49,7.25 -4.95,4.86 -7.43,10.75 -7.43,17.75l0 37.98c-8.7,2.04 -17.15,4.6 -25.26,7.76 -8.19,3.16 -15.95,6.74 -23.29,10.75l-29.96 -29.53c-4.69,-4.94 -10.4,-7.5 -17.32,-7.5 -6.83,0 -12.71,2.56 -17.75,7.5l-36.43 36.54c-5.03,5.03 -7.51,10.92 -7.51,17.73 0,6.83 2.48,12.81 7.51,17.75l26.97 27.06c-4.7,7.26 -8.79,14.93 -12.46,22.95 -3.68,8.02 -6.83,16.22 -9.56,24.49l-41.47 0c-7.01,0 -12.9,2.39 -17.76,7.26 -4.86,4.86 -7.25,10.75 -7.25,17.75l0 52.05c0,6.65 2.39,12.46 7.25,17.5 4.86,4.94 10.75,7.42 17.76,7.42l37.97 0c2.04,8.7 4.6,17.15 7.76,25.25 3.17,8.2 6.75,16.13 10.75,23.81l-29.52 29.44c-4.95,4.7 -7.51,10.41 -7.51,17.33 0,6.82 2.56,12.71 7.51,17.75l36.53 36.95c5.03,4.69 10.92,7 17.75,7 6.82,0 12.79,-2.31 17.75,-7l27.04 -27.48c7.26,4.69 14.94,8.78 22.96,12.46 8.02,3.66 16.21,6.83 24.49,9.55l0 41.48c0,7 2.39,12.88 7.25,17.74 4.86,4.87 10.76,7.26 17.75,7.26l52.05 0c6.66,0 12.46,-2.39 17.5,-7.26 4.94,-4.86 7.42,-10.74 7.42,-17.74l0 -37.98c8.7,-2.04 17.15,-4.6 25.25,-7.76 8.2,-3.16 16.14,-6.74 23.81,-10.75l29.44 29.53c4.7,4.95 10.49,7.5 17.51,7.5 7.07,0 12.87,-2.55 17.57,-7.5l36.95 -36.53c4.69,-5.04 7,-10.92 7,-17.75 0,-6.82 -2.31,-12.8 -7,-17.75l-27.48 -27.05c4.7,-7.26 8.79,-14.93 12.46,-22.96 3.66,-8.01 6.83,-16.21 9.56,-24.49l41.47 0c7,0 12.88,-2.4 17.74,-7.25 4.87,-4.87 7.26,-10.75 7.26,-17.75l0 -52.05c0,-6.66 -2.39,-12.45 -7.26,-17.5 -4.86,-4.95 -10.74,-7.42 -17.74,-7.42l-37.98 0c-2.04,-8.36 -4.6,-16.73 -7.76,-25 -3.16,-8.37 -6.74,-16.21 -10.75,-23.56l29.53 -29.95c4.95,-4.69 7.5,-10.41 7.5,-17.32 0,-6.83 -2.55,-12.71 -7.5,-17.75l-36.53 -36.43zm-48.41 257.98c-22.72,42.52 -67.54,71.44 -119.1,71.44 -51.58,0 -96.37,-28.92 -119.09,-71.42 2.66,-11.61 7.05,-21.74 19.9,-28.84 17.76,-9.89 48.34,-9.15 62.89,-22.24l20.1 52.78 10.1 -28.77 -4.95 -5.42c-3.72,-5.44 -2.44,-11.62 4.46,-12.74 2.33,-0.37 4.95,-0.14 7.47,-0.14 2.69,0 5.68,-0.25 8.22,0.32 6.41,1.41 7.07,7.62 3.88,12.56l-4.95 5.42 10.11 28.77 18.18 -52.78c13.12,11.8 48.43,14.18 62.88,22.24 12.89,7.22 17.26,17.24 19.9,28.82zm-159.11 -86.45c-1.82,0.03 -3.31,-0.2 -4.93,-1.1 -2.15,-1.19 -3.67,-3.24 -4.7,-5.55 -2.17,-4.86 -3.89,-17.63 1.57,-21.29l-1.02 -0.66 -0.11 -1.41c-0.21,-2.57 -0.26,-5.68 -0.32,-8.95 -0.2,-12 -0.45,-26.56 -10.37,-29.47l-4.25 -1.26 2.81 -3.38c8.01,-9.64 16.38,-18.07 24.82,-24.54 9.55,-7.33 19.26,-12.2 28.75,-13.61 9.77,-1.44 19.23,0.75 27.97,7.62 2.57,2.03 5.08,4.48 7.5,7.33 9.31,0.88 16.94,5.77 22.38,12.75 3.24,4.16 5.71,9.09 7.29,14.33 1.56,5.22 2.24,10.77 1.95,16.23 -0.53,9.8 -4.2,19.35 -11.61,26.33 1.3,0.04 2.53,0.33 3.61,0.91 4.14,2.15 4.27,6.82 3.19,10.75 -1.08,3.28 -2.44,7.08 -3.73,10.28 -1.56,4.31 -3.85,5.12 -8.27,4.65 -9.93,43.45 -69.98,44.93 -82.53,0.04zm40.01 -135.69c87.64,0 158.63,71.04 158.63,158.63 0,87.64 -71.04,158.63 -158.63,158.63 -87.63,0 -158.63,-71.04 -158.63,-158.63 0,-87.64 71.04,-158.63 158.63,-158.63z"
      />
    </svg>
  );
};

export const Tick = ({
  className,
  size,
}: {
  className?: string;
  size?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size ?? 512}
      height={size ?? 457.57}
      className={className}
      viewBox="0 0 512 457.57"
      fillRule="evenodd">
      <path d="M0,220.57c100.43-1.33,121-5.2,191.79,81.5,54.29-90,114.62-167.9,179.92-235.86C436-.72,436.5-.89,512,.24,383.54,143,278.71,295.74,194.87,457.57,150,361.45,87.33,280.53,0,220.57Z" />
    </svg>
  );
};

export const Remove = ({
  className,
  size,
  color,
}: {
  className?: string;
  size?: number;
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      imageRendering="optimizeQuality"
      fillRule="evenodd"
      clipRule="evenodd"
      viewBox="0 0 512 508.33"
      width={size ?? 512}
      height={size ?? 508.33}
      className={className}>
      <path
        fill={color}
        d="M317.99 323.62c-17.23-19.89-35.3-40.09-54.23-60.09-62.06 59.35-119.53 126.18-161.12 201.73-51.02 92.68-126.31 16.84-92.15-50.33 27.46-61.28 98.07-146.3 182.94-220.07-46.74-41.72-97.97-79.34-154.08-107.07C-42.76 47.2 19.97-20.82 79.37 6.16c50.04 19.82 119.09 70.85 182.26 134.32 63.11-45.86 129.55-81.8 189.45-95.87 13-3.06 50.95-11.33 59.69 1.04 3.29 4.67-.33 11.68-7.08 19.29-22.99 25.96-84.78 67.12-114.72 90.82-21.61 17.11-43.55 34.99-65.37 53.71 23.2 28.81 43.94 58.64 60.47 88.17 14.37 25.66 25.55 51.1 32.42 75.46 3.14 11.13 11.75 43.64 1.38 51.66-3.91 3.03-10.11.16-16.95-5.38-23.34-18.89-61.29-70.77-82.93-95.76z"
      />
    </svg>
  );
};

export const Map = ({
  className,
  size,
  title,
  color,
}: {
  className?: string;
  size?: number;
  title?: string;
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      viewBox="0 0 105.93 122.88"
      width={size ?? 105.93}
      height={size ?? 122.88}
      className={className}>
      <title>{title}</title>
      <path
        fill={color}
        d="M56.92,73.14a1.62,1.62,0,0,1-1.86.06A65.25,65.25,0,0,1,38.92,58.8,51.29,51.29,0,0,1,28.06,35.37C26.77,27.38,28,19.7,32,13.45a27,27,0,0,1,6-6.66A29.23,29.23,0,0,1,56.36,0,26,26,0,0,1,73.82,7.12a26,26,0,0,1,4.66,5.68c4.27,7,5.19,16,3.31,25.12A55.29,55.29,0,0,1,56.92,73.14Zm-19,.74V101.7l30.15,13V78.87a65.17,65.17,0,0,0,6.45-5.63v41.18l25-12.59v-56l-9.61,3.7a61.61,61.61,0,0,0,2.38-7.81l9.3-3.59A3.22,3.22,0,0,1,105.7,40a3.18,3.18,0,0,1,.22,1.16v62.7a3.23,3.23,0,0,1-2,3L72.72,122.53a3.23,3.23,0,0,1-2.92,0l-35-15.17L4.68,122.53a3.22,3.22,0,0,1-4.33-1.42A3.28,3.28,0,0,1,0,119.66V53.24a3.23,3.23,0,0,1,2.32-3.1L18.7,43.82a58.63,58.63,0,0,0,2.16,6.07L6.46,55.44v59l25-12.59V67.09a76.28,76.28,0,0,0,6.46,6.79ZM55.15,14.21A13.72,13.72,0,1,1,41.43,27.93,13.72,13.72,0,0,1,55.15,14.21Z"
      />
    </svg>
  );
};

export const Call = ({
  className,
  size,
  title,
  color,
}: {
  className?: string;
  size?: number;
  title?: string;
  color?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 122.88 118.72"
      xmlSpace="preserve"
      width={size ?? 122.88}
      height={size ?? 118.72}
      className={className}>
      <title>{title}</title>
      <g>
        <path
          fill={color}
          d="M29.22,56.54c3.57,6.43,7.67,12.6,13.02,18.24C47.58,80.45,54.24,85.6,62.86,90c0.64,0.31,1.25,0.31,1.78,0.1 c0.82-0.31,1.66-0.99,2.48-1.81c0.64-0.64,1.43-1.66,2.26-2.77c3.31-4.36,7.42-9.77,13.21-7.07c0.13,0.06,0.23,0.13,0.35,0.19 l19.33,11.11c0.06,0.03,0.13,0.1,0.19,0.13c2.55,1.75,3.6,4.46,3.63,7.52c0,3.12-1.15,6.63-2.83,9.58 c-2.22,3.91-5.51,6.5-9.29,8.21c-3.6,1.66-7.61,2.55-11.46,3.12c-6.05,0.89-11.71,0.32-17.5-1.46c-5.67-1.75-11.37-4.65-17.6-8.5 l-0.46-0.29c-2.86-1.78-5.95-3.7-8.98-5.95c-11.1-8.38-22.4-20.47-29.76-33.78C2.03,57.15-1.34,45.09,0.5,33.59 c1.02-6.3,3.72-12.03,8.44-15.82c4.11-3.31,9.64-5.13,16.81-4.49c0.82,0.06,1.56,0.54,1.94,1.24l12.39,20.94 c1.81,2.35,2.04,4.68,1.05,7.01c-0.82,1.91-2.48,3.67-4.74,5.31c-0.67,0.57-1.46,1.15-2.29,1.75c-2.77,2.01-5.92,4.33-4.84,7.07 L29.22,56.54L29.22,56.54L29.22,56.54z M73.35,7.55c-0.51-0.04-0.99-0.18-1.42-0.4c-0.45-0.23-0.84-0.54-1.16-0.91 c-0.32-0.38-0.57-0.81-0.73-1.29C69.9,4.49,69.84,4,69.88,3.49l0.01-0.07c0.04-0.49,0.18-0.95,0.39-1.36l0.04-0.07 c0.22-0.42,0.52-0.79,0.87-1.08c0.37-0.32,0.81-0.57,1.29-0.73c0.45-0.15,0.93-0.21,1.42-0.18l0.1,0.01 c3.43,0.27,6.74,0.79,9.92,1.55c3.21,0.77,6.27,1.8,9.16,3.05c2.91,1.27,5.65,2.78,8.2,4.52c2.54,1.74,4.91,3.71,7.06,5.9 c2.13,2.17,4.06,4.56,5.77,7.15c1.69,2.57,3.16,5.34,4.4,8.28c1.2,2.88,2.18,5.94,2.92,9.18c0.72,3.17,1.21,6.5,1.45,9.98 l0.01,0.17l0,0.18c0,0.46-0.08,0.91-0.23,1.33c-0.16,0.45-0.4,0.85-0.71,1.2c-0.31,0.35-0.68,0.64-1.1,0.86 c-0.39,0.21-0.84,0.34-1.31,0.4l-0.2,0.02l-0.19,0c-0.47,0.01-0.92-0.07-1.34-0.23c-0.44-0.16-0.85-0.4-1.2-0.71 c-0.37-0.32-0.68-0.72-0.9-1.17c-0.21-0.43-0.35-0.92-0.38-1.42c-0.21-3.09-0.63-6.03-1.26-8.8c-0.63-2.83-1.48-5.5-2.52-8.01 c-1.04-2.52-2.29-4.88-3.72-7.06c-1.45-2.21-3.08-4.23-4.88-6.07c-1.82-1.85-3.81-3.51-5.97-4.98c-2.17-1.48-4.51-2.76-7.01-3.84 l-0.04-0.02c-2.48-1.07-5.11-1.95-7.88-2.61C79.29,8.23,76.39,7.78,73.35,7.55L73.35,7.55z M65.03,43.21 c-0.51-0.05-0.99-0.21-1.41-0.43c-0.44-0.24-0.83-0.56-1.13-0.94c-0.29-0.36-0.52-0.78-0.67-1.23c-0.14-0.42-0.2-0.87-0.18-1.33 c0.01-0.13,0.01-0.23,0.03-0.35c0.07-0.48,0.23-0.93,0.45-1.32c0.23-0.41,0.54-0.77,0.9-1.06c0.36-0.29,0.78-0.52,1.23-0.67 c0.42-0.13,0.87-0.2,1.34-0.18l0.35,0.03c1.49,0.16,2.92,0.42,4.3,0.77c1.4,0.36,2.73,0.82,3.98,1.36l0.04,0.02 c1.27,0.56,2.46,1.21,3.57,1.96c1.12,0.76,2.16,1.61,3.12,2.57c0.95,0.95,1.81,1.98,2.57,3.1c0.76,1.11,1.42,2.3,1.99,3.58 c0.55,1.25,1.01,2.58,1.37,3.98c0.35,1.37,0.6,2.83,0.76,4.37c0.05,0.51,0,1.01-0.13,1.47l-0.01,0.04 c-0.14,0.46-0.38,0.89-0.67,1.26l-0.01,0.02c-0.31,0.38-0.69,0.69-1.13,0.93c-0.42,0.23-0.9,0.38-1.41,0.43l-0.05,0 c-0.49,0.04-0.97-0.01-1.42-0.14c-0.48-0.14-0.92-0.38-1.3-0.69l-0.01,0c-0.38-0.31-0.7-0.69-0.94-1.14 c-0.23-0.42-0.38-0.9-0.43-1.4l0-0.04c-0.11-1.09-0.29-2.13-0.54-3.12c-0.25-1.01-0.57-1.95-0.95-2.82 c-0.38-0.87-0.82-1.68-1.32-2.42c-0.51-0.75-1.07-1.43-1.69-2.05c-0.62-0.62-1.31-1.18-2.06-1.68c-0.75-0.5-1.57-0.94-2.46-1.33 l-0.05-0.02c-0.87-0.38-1.81-0.69-2.8-0.94C67.22,43.51,66.15,43.33,65.03,43.21L65.03,43.21z M69.03,25.99l-0.1,0l-0.13-0.02 c-0.47-0.05-0.91-0.19-1.3-0.39c-0.42-0.22-0.79-0.51-1.1-0.85l0,0c-0.32-0.36-0.57-0.77-0.73-1.23c-0.15-0.43-0.23-0.89-0.22-1.38 l0-0.17l0.02-0.16c0.05-0.46,0.19-0.9,0.39-1.29c0.22-0.42,0.51-0.8,0.85-1.1c0.37-0.33,0.8-0.58,1.28-0.75 c0.46-0.16,0.95-0.23,1.46-0.2c2.66,0.16,5.19,0.5,7.58,1.01c2.4,0.51,4.67,1.2,6.78,2.06c2.13,0.87,4.12,1.92,5.96,3.14 c1.82,1.21,3.5,2.6,5.01,4.17c1.5,1.55,2.84,3.27,4,5.15c1.15,1.86,2.14,3.88,2.94,6.05c0.78,2.12,1.4,4.4,1.84,6.84 c0.43,2.4,0.69,4.93,0.77,7.62l0.01,0.14c0,0.48-0.09,0.95-0.27,1.38c-0.18,0.45-0.44,0.85-0.76,1.2c-0.33,0.36-0.74,0.65-1.2,0.85 c-0.43,0.2-0.92,0.31-1.43,0.33l-0.17,0c-0.48-0.01-0.93-0.1-1.35-0.27c-0.45-0.18-0.85-0.44-1.19-0.76 c-0.36-0.34-0.65-0.74-0.86-1.2c-0.2-0.44-0.31-0.92-0.33-1.44c-0.06-2.24-0.28-4.35-0.63-6.34c-0.35-2.01-0.85-3.88-1.47-5.6 c-0.62-1.72-1.38-3.3-2.26-4.75c-0.89-1.46-1.91-2.77-3.05-3.96c-1.16-1.19-2.44-2.26-3.85-3.19c-1.42-0.94-2.99-1.75-4.67-2.43 l-0.04-0.02c-1.7-0.67-3.52-1.22-5.47-1.63c-1.96-0.41-4.05-0.69-6.25-0.82L69.03,25.99L69.03,25.99z"
        />
      </g>
    </svg>
  );
};

export const RightArrow = ({
  className,
  size,
  title,
}: {
  className?: string;
  size?: number;
  title?: string;
}) => {
  return (
    <svg
      viewBox="0 0 122.883 122.882"
      enableBackground="new 0 0 122.883 122.882"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size ?? 122.88}
      height={size ?? 122.88}
      className={className}
      xmlSpace="preserve">
      <title>{title}</title>
      <g>
        <path d="M61.441,0C44.475,0,29.115,6.877,17.996,17.996C6.877,29.115,0,44.475,0,61.441c0,16.966,6.877,32.326,17.996,43.445 c11.119,11.118,26.479,17.995,43.445,17.995c16.967,0,32.327-6.877,43.446-17.995c11.119-11.119,17.996-26.479,17.996-43.445 c0-16.967-6.877-32.327-17.996-43.445C93.768,6.877,78.408,0,61.441,0L61.441,0z M51.505,42.166 c-1.735-1.784-1.696-4.637,0.088-6.372c1.784-1.735,4.637-1.696,6.373,0.088l21.839,22.521l-3.23,3.142l3.244-3.146 c1.738,1.792,1.693,4.652-0.098,6.39c-0.053,0.05-0.105,0.099-0.158,0.146L57.966,87.017c-1.735,1.784-4.588,1.823-6.373,0.088 c-1.784-1.734-1.823-4.588-0.088-6.372l18.78-19.201L51.505,42.166L51.505,42.166z M24.386,24.386 C33.869,14.903,46.97,9.038,61.441,9.038c14.471,0,27.573,5.865,37.055,15.348c9.484,9.483,15.35,22.584,15.35,37.056 c0,14.471-5.865,27.572-15.35,37.055c-9.482,9.483-22.584,15.349-37.055,15.349c-14.471,0-27.572-5.865-37.055-15.349 C14.903,89.014,9.038,75.912,9.038,61.441C9.038,46.97,14.903,33.869,24.386,24.386L24.386,24.386z" />
      </g>
    </svg>
  );
};

export const LeftArrow = ({
  className,
  size,
  title,
}: {
  className?: string;
  size?: number;
  title?: string;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size ?? 122.88}
      height={size ?? 122.88}
      className={className}
      viewBox="0 0 122.883 122.882"
      enableBackground="new 0 0 122.883 122.882"
      xmlSpace="preserve">
      <title>{title}</title>
      <g>
        <path d="M61.441,0c16.967,0,32.327,6.877,43.446,17.996c11.119,11.119,17.996,26.479,17.996,43.445 c0,16.966-6.877,32.326-17.996,43.445c-11.119,11.118-26.479,17.995-43.446,17.995c-16.966,0-32.326-6.877-43.445-17.995 C6.877,93.768,0,78.407,0,61.441c0-16.967,6.877-32.327,17.996-43.445C29.115,6.877,44.475,0,61.441,0L61.441,0z M71.377,42.166 c1.736-1.784,1.695-4.637-0.088-6.372s-4.637-1.696-6.373,0.088L43.078,58.402l3.23,3.142l-3.244-3.146 c-1.737,1.792-1.693,4.652,0.099,6.39c0.052,0.05,0.104,0.099,0.158,0.146l21.595,22.082c1.736,1.784,4.59,1.823,6.373,0.088 c1.783-1.734,1.824-4.588,0.088-6.372L52.598,61.531L71.377,42.166L71.377,42.166z M98.496,24.386 C89.014,14.903,75.912,9.038,61.441,9.038s-27.572,5.865-37.055,15.348C14.903,33.869,9.038,46.97,9.038,61.441 c0,14.471,5.865,27.572,15.349,37.055c9.482,9.483,22.583,15.349,37.055,15.349s27.573-5.865,37.055-15.349 c9.484-9.482,15.35-22.584,15.35-37.055C113.846,46.97,107.98,33.869,98.496,24.386L98.496,24.386z" />
      </g>
    </svg>
  );
};
